function parallax(parallax_container){
	parallax_container.forEach(function(hero) {
		var depth, layer, layers, movement, topDistance, translate3d, _i, _len;
		topDistance = hero.getBoundingClientRect().top;

		layers = hero.querySelectorAll("[data-type='parallax']");
		for (_i = 0, _len = layers.length; _i < _len; _i++) {
			layer = layers[_i];
			depth = layer.getAttribute('data-depth');
			movement = topDistance * depth;
			translate3d = 'translate3d(0, ' + movement + 'px, 0)';

			//for scale
			//scale = Math.abs(movement / 1000);
			//trasnlateScale = 'scale('+scale+')';
			layer.style['-webkit-transform'] = translate3d;
			layer.style['-moz-transform'] = translate3d;
			layer.style['-ms-transform'] = translate3d;
			layer.style['-o-transform'] = translate3d;
			layer.style.transform = translate3d;
		}
	});
} 

(function() {
	var parallax_container = document.querySelectorAll('.parallax-container')
	if (window.innerWidth < 760)
		var parallax_container = document.querySelectorAll('.parallax-container:not(.no-parallax-mobile)');

	parallax(parallax_container)

	window.addEventListener('scroll', function(event) {
		parallax(parallax_container)
	});

}).call(this);